import { ComponentType } from 'react';

import { CheckCircleIcon, CloudOffIcon, Hourglass03Icon } from '@/assets/icons';
import { IBadge } from '@/components/common';

import { FieldChanged, UserStatus } from '@/features/user-management/enums';

export const getUserStatusLabel = (status: UserStatus): string => {
  switch (status) {
    case UserStatus.Inactive:
      return 'Inactive';
    case UserStatus.Pending:
      return 'Pending';
    case UserStatus.Active:
      return 'Active';
    default:
      return 'N/A';
  }
};

export const getUserStatusIcon = (status: UserStatus): ComponentType<{ className?: string }> => {
  switch (status) {
    case UserStatus.Inactive:
      return CloudOffIcon;
    case UserStatus.Pending:
      return Hourglass03Icon;
    case UserStatus.Active:
      return CheckCircleIcon;
    default:
      return CloudOffIcon;
  }
};

export const getUserStatusVariant = (status: UserStatus): IBadge['variant'] => {
  switch (status) {
    case UserStatus.Inactive:
      return 'neutral-3';
    case UserStatus.Pending:
      return 'yellow';
    case UserStatus.Active:
      return 'green';
    default:
      return 'neutral-3';
  }
};

export const getFieldChangedLabel = (fieldChanged: FieldChanged): string => {
  switch (fieldChanged) {
    case FieldChanged.Status:
      return 'Status';
    case FieldChanged.Role:
      return 'Role';
  }
};
